export const language: any = {
  title: "Hey ! Communauté Cooker",
  follow: "Suivre",
  follower: "Abonné",
  post_share: "Publication partagée",
  like_share: "J'aime",
  report: "Signaler une infraction",
  delete_post: "Supprimer la publication",
  delete_comment: "Supprimer le commentaire",
  confirm_report: "Êtes-vous sûr que cette publication enfreint les règles de la communauté ? Si le signalement est validé, vous ne pourrez plus voir cette publication.",
  confirm_report_comment: "Êtes-vous sûr que ce commentaire enfreint les règles de la communauté ?",
  toats_report: "Merci d’avoir signalé. Votre signalement est en cours d’examen.",
  confirm_delete: "Voulez-vous vraiment supprimer cette publication ?",
  confirm_delete_comment: "Voulez-vous vraiment supprimer ce commentaire ?",
  toast_delete: "Supprimé avec succès !",
  text_yes: "Oui",
  text_no: "Non",
  create: {
    title: "Créer une publication - Hey! Cooker Communauté",
    content_placeholder: "Saisissez le contenu de la publication",
    submit: "Partager maintenant",
    add_image_by_camera: "Prendre une photo",
    add_image_by_gallery: "Choisir une photo",
    add_video_by_camera: "Enregistrer une vidéo",
    add_video_by_gallery: "Choisir une vidéo"
  },
  detail: {
    shared: "Partagé",
    shared_community: "Photo (vidéo) partagée avec la communauté"
  },
  follwed: "Suivi",
  comment: {
    placeholder: "Veuillez entrer un commentaire",
    submit: "Envoyer",
    nodata: "Laissez un commentaire ici et soyez le premier à commenter !",
    load_more: "Voir plus de commentaires",
    not_login: "Veuillez vous connecter pour commenter",
    delete: "Supprimer le commentaire",
    delete_confirm: "Êtes-vous sûr de vouloir supprimer ce commentaire ?",
    delete_success: "Commentaire supprimé avec succès",
    report: "Signaler",
    report_confirm: "Êtes-vous sûr que ce commentaire enfreint les règles de la communauté ?",
    report_success: "Merci pour votre signalement,\nvotre rapport est en cours d'examen",
  },
  bottom_navigation: "Communauté",
  shared_post: "A partagé la publication"
};
